declare const Fancybox: {
  bind: (selector: string, options: FancyboxOptions) => void;
};

import type { FancyboxOptions } from "./fancybox-options";

export function initFancybox({ attribute, options }: { attribute: string; options: FancyboxOptions }) {
  Fancybox.bind(`[${attribute}]`, options);
}